import React from 'react';
import { IonContent, IonRow, IonPage } from '@ionic/react';
import { useHistory } from "react-router-dom";
import './UpsellPage.scss';

import { formatCurrency } from '../helpers/currencyHelpers';

import { ApplicationState } from '../store';
import { useSelector } from 'react-redux';

import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import * as BasketStore from '../store/BasketStore';
import * as MenuItemStore from '../store/MenuItemStore';
import MenuItemTile from '../components/MenuItemTile';
import { simpleChannelType } from '../store/LocationStore';
import AllergenPopup from '../modals/AllergenPopup';

const UpsellPage: React.FC = () => {
    let history = useHistory();

    const basketStore = useSelector((state: ApplicationState) => state.basket);
    const pfIdentifier = localStorage.getItem("pfidentifier");

    const boundUpsellDone = bindActionCreators(BasketStore.actionCreators.upsellDone, useDispatch());

    const boundRequestMenuItem = bindActionCreators(MenuItemStore.actionCreators.requestMenuItem, useDispatch());

    const locationStore = useSelector((state: ApplicationState) => state.location);

    const showAllergenPopup = useSelector((state: ApplicationState) => state.basket?.showAllergen);
    const setShowAllergenPopup = bindActionCreators(BasketStore.actionCreators.showAllergen, useDispatch());

    const isLoggedIn = localStorage.getItem('isLoggedIn') === "true" ? true : false

    const goToNextPage = () => {
        setShowAllergenPopup(false);

        switch (locationStore?.selectedChannel?.channelType) {
            case simpleChannelType.ClickAndCollect:
                isLoggedIn ?
                    history.push("/name-or-nickname")
                    :
                    history.push("/enteremail");
                break;
            case simpleChannelType.TableOrder:
                isLoggedIn ?
                    history.push("/name-or-nickname")
                    :
                    history.push("/tablenumber");
                break;
        }
    };

    const navigateToMenuItem = (menuItemId: number, referrer: string | null,) => {
        boundUpsellDone();

        boundRequestMenuItem(menuItemId, pfIdentifier ?? "", referrer, () => {
            history.push(`/menuitem/${menuItemId}`);
        });
    }

    return (
        <IonPage >
            <IonContent fullscreen className="UpsellPage">
                <div className="BasicGrid__wrapper">
                    <IonRow className="categoryGrid">
                        {basketStore && basketStore.upsells && basketStore.upsells.map((a: IMopMenuItemDetail, i) => {
                            return (
                                <MenuItemTile
                                    kcal={a.kcal}
                                    name={a.menuItemName}
                                    key={"ef" + a.menuItemId}
                                    menuItemId={a.menuItemId}
                                    inStock={a.inStock}
                                    fromPrice={a.menuItemFromPrice != null}
                                    price={a.menuItemFromPrice ? formatCurrency(a.menuItemFromPrice) : formatCurrency(a.menuItemBasePrice)}
                                    onAddClick={() => navigateToMenuItem(a.menuItemId, a.referrer)} sku={a.sku} productFlags={a.productFlags}
                                    plpRoundels={a.plpRoundels} />
                            )
                        })}
                    </IonRow>
                </div>
                <AllergenPopup
                    show={showAllergenPopup}
                    close={() => setShowAllergenPopup(false)}
                    accept={goToNextPage}
                />
            </IonContent>
        </IonPage>
    );
};

export default UpsellPage;
